import React from 'react';
import PopUp from '../../Popup';

const JoinMeOnTourPopUp = (props) => {
    const { message } = props;

    return (
        <PopUp
            className="popup-sm"
            onCloseClick={props.closePopup}
            config={{
                fullScreen: false,
                scrollable: false,
                style: { maxHeight: '300px' },
            }}
        >
            {
                <h5>{message}</h5>
            }
            <button
                type="button"
                onClick={props.closePopup}
                className="btn btn-primary btn-xl text-uppercase btn-block mt24"
            >
                Got it
            </button>
        </PopUp>
    );
};

export default JoinMeOnTourPopUp;
